import { TPresenceItem } from '@/types/presences';
import { convertDatesToSeconds } from '@/utils/hh-mm-ss-into-number';

/**
 * Returns the presence whose time window contains `seekedSeconds` (relative to
 * `baseStartDatetime`), or `null` if none matches.
 *
 * Used when the user manually scrubs the video progress bar in either direction:
 * the next `onProgress` tick may not be granular enough to detect the presence,
 * so this function performs a direct lookup at the exact seeked position.
 *
 * @param seekedSeconds  - Absolute offset in seconds from `baseStartDatetime`.
 * @param baseStartDatetime - The start datetime of the segment or clip (ISO string).
 * @param collection - Flat, ordered list of presences to search.
 */
export const getPresenceAtTime = (
  seekedSeconds: number,
  baseStartDatetime: string,
  collection: TPresenceItem[]
): TPresenceItem | null => {
  return (
    collection.find(presence => {
      const startSeconds = Math.abs(
        convertDatesToSeconds(baseStartDatetime, presence.start_datetime)
      );
      const endSeconds = Math.abs(convertDatesToSeconds(baseStartDatetime, presence.end_datetime));
      return seekedSeconds >= startSeconds && seekedSeconds <= endSeconds;
    }) ?? null
  );
};
